import styled from '@emotion/styled';

export const FilterContentDisplay = styled.div`
  padding: 12px;
  font-size: 13px;
`;
